import { INodeTemplate } from '@/types/node';
import { Edit } from './edit';
import { Render } from './render';

const template: INodeTemplate = {
  version: 1,
  name: 'Pretix QR Code',
  icon: 'qr_code_2',
  type: 'pretix-ticket',
  tag: 'setup & tools',
  content: {},
  override: {
    root: {},
  },
  supports: {
    contexts: ['page'],
    appender: true,
  },
};

export { template, Render, Edit };
